import {axiosNodeClient} from '../http';

export const customerGroupServiceNode = {get, create, update, del, getCustomerInGroup, assginCustomersToGroup, removeCustomerInGroup}

function get(id) {
    if (id) {
        return axiosNodeClient.get(`/customer-group/${id}`);
    } else {
        return axiosNodeClient.get('/customer-group');
    }
}

function countCustomerInGroup(ids) {
    return axiosNodeClient.get(`/customer-group/count-customer`, {
        params: {
            ids: ids.join()
        }
    });
}

function create(customerGroup) {
    return axiosNodeClient.post('/customer-group', customerGroup);
}

function update(id, data) {
    return axiosNodeClient.put(`/customer-group/${id}`, data);
}

function del(id) {
    return axiosNodeClient.delete(`/customer-group/${id}`);
}

function getCustomerInGroup(id) {
    return axiosNodeClient.get(`/customer-group/${id}/customer`);
}


const initDataAssigin = {store_id: 0, group_id: 0, customer_ids: []};
function assginCustomersToGroup(data = initDataAssigin) {
    return axiosNodeClient.post(`/customer-group/${data.group_id}/customers/assign`, data);
}

function removeCustomerInGroup(data  = initDataAssigin) {
    return axiosNodeClient.post(`/customer-group/${data.group_id}/customers/remove`, data);
}
